import {z} from 'zod';

/**
 * Schema for prompt response
 */
export const promptSchema = z.object({
  id: z.string().uuid(),
  useCaseType: z.string(),
  userPrompt: z.string(),
  systemPrompt: z.string(),
  createdBy: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Prompt = z.infer<typeof promptSchema>;
